import { IconInterface } from '../interfaces/icon.interface';

const CheckmarkSmall = (props: IconInterface) => {
	const { color = '#454545', reverseColor, secondColor } = props;

	return (
		<svg
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="9" cy="9" r="9" fill={reverseColor ? 'white' : color} />
			<path
				d="M5 9L6.45771 10.4875C7.26228 11.3085 8.59168 11.2839 9.36535 10.4337L13.4 6"
				stroke={reverseColor ? color : secondColor || 'white'}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default CheckmarkSmall;
